import React from 'react';
import PropTypes from 'prop-types';
import { ReactReduxContext, connect } from 'react-redux';

import CompanyForm from './company';
import QuickbooksSelect from 'bundles/backoffice/quickbooks/select';
import CustomFields from './custom_fields';
import ManagedInput from 'components/form/managed_input';
import PersonForm from './person';
import TagsInput from 'bundles/crm/tags/input';
import TagsInputLabel from 'bundles/crm/tags/input/contact_form_label';
import typeOptions from 'bundles/backoffice/contacts/type_options';

class ContactForm extends React.Component {
  static propTypes = {
    allowSavingPrivateContacts: PropTypes.bool,
    allowTagging: PropTypes.bool,
    contact: PropTypes.shape({
      contactType: PropTypes.string.isRequired,
      crmTags: PropTypes.array.isRequired,
      id: PropTypes.number,
      quickbooksCustomerId: PropTypes.number,
      quickbooksVendorId: PropTypes.number,
      visibility: PropTypes.string,
    }).isRequired,
    contactType: PropTypes.string,
    extraFormSections: PropTypes.node,
    requestPermissions: PropTypes.bool,
    showQuickbooks: PropTypes.bool,
    onChange: PropTypes.func.isRequired
  };

  render() {
    return <div className="d-flex flex-column gap-6">
      {this.props.contactType || this.props.contact.id ? null : this.renderType()}
      {this.props.requestPermissions && this.renderPermissionsInputs()}
      {this.props.allowTagging && this.renderTags()}
      {this.props.contact.contactType === 'business' ? this.renderCompanyForm() : this.renderPersonForm()}
      {this.props.showQuickbooks && this.renderQuickbooks()}
      <CustomFields contact={this.props.contact} onChange={this.props.onChange} />
    </div>;
  }

  renderType() {
    return (
      <div className="form-vertical-field-container">
        <h6>Type</h6>
        <ManagedInput
          aria-label="contactType"
          name="contactType"
          options={typeOptions}
          type="radioGroup"
          value={this.props.contact.contactType}
          onChange={this.props.onChange}
        />
      </div>
    );
  }

  renderPermissionsInputs() {
    const options = [];
    options.push({ label: 'Public', value: 'public' });

    if (this.props.allowSavingPrivateContacts) {
      options.push({ label: 'Private', value: 'private' });
    }

    if (options.length === 1) {
      return null;
    }

    return (
      <div className="form-vertical-field-container">
        <h6>Permissions</h6>
        <ManagedInput
          name="visibility"
          options={options}
          required
          type="radioGroup"
          value={this.props.contact.visibility}
          onChange={this.props.onChange}
        />
      </div>
    );
  }

  renderTags() {
    return (
      <div>
        <TagsInputLabel />
        <TagsInput
          value={this.props.contact.crmTags}
          onValueChange={crmTags => this.props.onChange({ crmTags })}
        />
      </div>
    );
  }

  renderQuickbooks() {
    return (
      <div className="form-vertical-field-container">
        <h6>QuickBooks Information</h6>
        <div className="form-group">
          <label className="form-label">Customer</label>
          <QuickbooksSelect
            buildoutObject={this.props.contact}
            quickbooksId={this.props.contact.quickbooksCustomerId}
            type="customer"
            onChange={customer => this.props.onChange({ quickbooksCustomer: customer })}
          />
        </div>
        <div className="form-group">
          <label className="form-label">Vendor</label>
          <QuickbooksSelect
            buildoutObject={this.props.contact}
            quickbooksId={this.props.contact.quickbooksVendorId}
            type="vendor"
            onChange={vendor => this.props.onChange({ quickbooksVendor: vendor })}
          />
        </div>
      </div >
    );
  }

  renderCompanyForm() {
    return (
      <CompanyForm
        contact={this.props.contact}
        extraSections={this.props.extraFormSections}
        onChange={this.props.onChange}
      />
    );
  }

  renderPersonForm() {
    return (
      <PersonForm
        allowSavingPrivateContacts={this.props.allowSavingPrivateContacts}
        contact={this.props.contact}
        extraSections={this.props.extraFormSections}
        onChange={this.props.onChange}
      />
    );
  }
}

const ConnectedContactForm = connect(
  (state, { showQuickbooks }) => ({
    showQuickbooks: showQuickbooks ?? state.features?.quickbooksAccountingIntegration
  })
)(ContactForm);

export default function ContactFormContainer(props) {
  const reduxContext = React.useContext(ReactReduxContext);
  return reduxContext ? <ConnectedContactForm {...props} /> : <ContactForm {...props} />;
}
